import SampleReportView from "@/components/samples/SampleReportView";
import { PERMIT_POWER_REPORT } from "@/data/sample-reports";

const PermitPowerSample = () => <SampleReportView report={PERMIT_POWER_REPORT} />;

export default PermitPowerSample;
